<div class="title">
  {{date | epochUTC:'MMM DD, YYYY'}}
</div>

<div class="rate-details" *ngIf="!module">
  <ng-container *ngIf="rate.category">
    <div class="line" *ngIf="rate.price || rate.weekend">
      <b>Category:</b> {{getCategoryName | call:rate.category}}
    </div>

    <div class="line" *ngIf="!isWeekend || !rate.weekend">
      <b>Nightly:</b> {{rate.price | rate:rental.currency}}
    </div>

    <div class="line" *ngIf="isWeekend && rate.weekend">
      <b>Weekend:</b> {{rate.weekend | rate:rental.currency}}
    </div>
  </ng-container>

  <div class="line" *ngFor="let item of (getRates | call:rate:rates:channels:true)">
    <b>{{item.name}}:</b> {{item.price | rate:rental.currency}}
  </div>

  <div class="line" *ngIf="rate.minimumStay">
    <b>Min Stay:</b> {{rate.minimumStay}}
  </div>

  <div class="line">
    <b>Max Stay:</b> {{rate.maximumStay || 'N/A'}}
  </div>
</div>

<div class="rate-details" *ngIf="module === 'rates-calendar'">
  <div class="line" *ngIf="rate?.price && rate?.category">
    <b>{{getCategoryName | call:rate.category:true}}:</b>
    {{(isWeekend && rate.weekend ? rate.weekend : rate.price) | rate:rental.currency}}
  </div>

  <ng-container *ngIf="(getRates | call:rate:rates:channels:false); let categoryRates">
    <div class="line" *ngFor="let item of categoryRates">
      <b>{{item.name}}:</b> {{item.price | rate:rental.currency}}
    </div>
  </ng-container>

  <ng-container *ngIf="(getRates | call:rate:rates:channels:true); let channelRates">
    <div class="line" *ngIf="channelRates.length">
      <b>Adjustments:</b>
    </div>
    <ul class="sub-lines">
      <li class="sub-line" *ngFor="let item of channelRates">
        <b>{{item.name}}:</b> {{item.price | rate:rental.currency}}
      </li>
    </ul>
  </ng-container>
</div>
